'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteGlobalButton', ['$rootScope', function ($rootScope) {
      return {
        template: '<div class="sa-note-global-button"></div>',
        restrict: 'A',
        link: function(scope, elem) {
          scope.state = {
            q: {
              overlayOpen: function() {
                return scope.state.overlayOpen;
              }
            }
          };

          $(elem).on('click touchstart', function() {
            if ($(elem).first().attr('sa-note-global-button') == 'close') {
              $rootScope.$broadcast('note-overlay-close');
            } else if ($(elem).first().attr('sa-note-global-button') == 'open') {
              $rootScope.$broadcast('note-overlay-open');
            }
          });

          scope.$on('note-overlay-close', function() {
            $('.open-button-container').removeClass('open');
            $('.close-button-container').removeClass('open');
          });

          scope.$on('note-overlay-open', function() {
            $('.open-button-container').addClass('open');
            $('.close-button-container').addClass('open');
          });

          if (elem[0].attributes[0].nodeValue == 'close') {
            // elem[0].firstChild.innerHTML = '<i class="icon-arrow-right"></i>';
          } else {
            elem[0].firstChild.innerHTML = '<i class="sa-icon-notes"></i><span>Open Notes</span>';
          }
        }
      };
    }]);
